import { useEffect, useState } from 'react';

// 搜尋框輸入停頓多久才送出請求
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * 回傳延遲更新的值：value 停止變動 delay 毫秒後才跟上。
 * 用於搜尋框，避免每打一個字就送一支請求。
 *
 * @param {*} value 會頻繁變動的值（例如輸入框內容）
 * @param {number} delay 停頓多少毫秒後才更新
 * @returns {*} 延遲後的值
 */
export function useDebouncedValue(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debouncedValue;
}
